import React from 'react'
import { Link } from "react-router-dom"
import about_pic from "../Data/sample_images/bmw_x6_1_new.png"

const AboutBlock = () => {
  return (
    <>
        <div className="container about-container">
            <h3 className="section-subtitle">AutoInsure</h3>
            <h1 className="section-title">About Us</h1>
            <div className="about-box">
                <div className="about-info-container">
                    <h1 className="about-title">Welcome to AutoInsure - Rent & Insure</h1>
                    <p className="section-caption">We provide rental cars and vans to meet every rental need. We also provide Car Insurance Quotas using real-tome data from GoCompare.com, Aviva & Compare The Market. Our car insurance tool is designed to take the hard work out of finding a cheap price. You fill in one questionnaire & it will provide a quote estimation for your chosen rental car.</p>
                    <p className="section-caption">Our extensive fleet ranges from compact city cars, ideal for navigating narrow bustling city streets to large people carriers, perfect for comfortably transporting the whole family in style. No matter the journey, we always guarantee quality!</p>
                    <Link to="/about">
                        <button className="btn btn-lg btn-light more-info">More Info</button>
                    </Link>
                    <Link to="/about#team">
                        <button className="btn btn-lg our-team">Our Team</button>
                    </Link>
                </div>
                <div className="about-img-container">
                    <img src={about_pic} alt="rental car" />
                </div>
            </div>
        </div>
    </>
  )
}

export default AboutBlock